import { MoneyInputValue } from "@oysterhr/feature-components"
import { useEffect, useState } from "react"
import { getCurrencyConversionFactor as getCurrencyConverterApiConversionFactor } from "~/app/services/currencyConversion"

const toTwoDecimalPlaces = (value: number) => Math.round(value * 100) / 100

export const useCurrencyConversionFactor = (
  officialCurrency: string,
  approximateCurrency: string,
  getCurrencyConversionFactor: (
    officialCurrency: string,
    approximateCurrency: string,
  ) => Promise<number> = getCurrencyConverterApiConversionFactor,
) => {
  const [factor, setFactor] = useState(0)

  useEffect(() => {
    getCurrencyConversionFactor(officialCurrency, approximateCurrency).then(data =>
      setFactor(data || 0),
    )
  }, [approximateCurrency, getCurrencyConversionFactor, officialCurrency])

  const toApproximate = (amount: MoneyInputValue["amount"] | number) =>
    toTwoDecimalPlaces(Number(amount) * factor)
  const toOfficial = (amount: MoneyInputValue["amount"] | number) =>
    toTwoDecimalPlaces(Number(amount) / factor)

  return { toApproximate, toOfficial }
}
